import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, shareReplay, tap } from "rxjs";
import { UsersContractResponse } from "../../../../../libs/shared/generated/src/lib/types/users";
import { EnvironmentService } from "../@core/services/environment.service";

@Injectable({
    providedIn: 'root',
})
export class ContractsService {
    private readonly apiUrl: string = '';
    private contractsToAccept$?: Observable<UsersContractResponse[]>;

    constructor(
        private readonly http: HttpClient,
        private readonly environmentService: EnvironmentService,
    ) {
        this.apiUrl = this.environmentService.utilitiesServiceUrl + '/contracts';
    }

    invalidateToAcceptCache(): void {
        this.contractsToAccept$ = undefined;
    }

    getToAccept(forceRefresh: boolean = false): Observable<UsersContractResponse[]> {
        if (!this.contractsToAccept$ || forceRefresh) {
            this.contractsToAccept$ = this.http
                .get<UsersContractResponse[]>(`${this.apiUrl}/to-accept`)
                .pipe(shareReplay(1));
        }

        return this.contractsToAccept$;
    }

    acceptContract(id: string): Observable<any> {
        return this.http
            .post<any>(`${this.apiUrl}/${id}/acceptances`, {})
            .pipe(tap(() => this.invalidateToAcceptCache()));
    }

    getContractById(id: string, token: string): Promise<any> {
        return new Promise((resolve) => {
            fetch(`${this.apiUrl}/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'it',
                    'Authorization': `Bearer ${token}`,
                }
            })
                .then(response => {
                    if (response.ok) {
                        resolve({ media: response.json() as unknown as UsersContractResponse, valid: true });
                    } else {
                        resolve({ media: null, valid: false });
                    }
                })
                .catch(() => {
                    resolve({ media: null, valid: false });
                });
            // this.http.get<boolean>(this.apiAppUrl + '/validate-token', { params: { token } }).subscribe({
            //   next: (res) => {
            //     resolve(res);
            //   },
            //   error: (err) => {
            //     resolve(false);
            //   },
            // });

        });
    }
}